import { render, staticRenderFns } from "./page_banner.vue?vue&type=template&id=66e6edae"
import script from "./page_banner.vue?vue&type=script&setup=true&lang=js"
export * from "./page_banner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./page_banner.vue?vue&type=style&index=0&id=66e6edae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports